import { InteractivityDesignDimensionsService, DesignDimensions } from './../../services/interactivity-design-dimensions.service';
import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { BbTableService, BbTableSelectOption, TableRow } from '../../../../../services/bb-table.service';
import { FilterSetService } from '../../../../../services/filter-set.service';
import { UploadService } from '../../../../../services/upload.service';
import { InteractivityEditorService } from '../../services/interactivity-editor.service';
import { InteractivityStateService } from '../../services/interactivity-state.service';
import { ContextMenuOption } from '../../../../shared/bb-context-menu/bb-context-menu.component';
import { InteractivityWidgetService } from '../../services/interactivity-widget.service';
import { WidgetType } from '../../enums/WidgetType';
import { SapiEntity, SapiService } from '../../../../../services/sapi.service';
import { PublicationService } from '../../../../../services/publication.service';
import { ModalDefinition, OverlayService } from '../../../../../services/overlay.service';
import { Mediaclip } from '../../../../../interfaces/mediaclip';
import { EntityService } from '../../../../../services/entity.service';

@Component({
	selector: 'portfolio',
	templateUrl: './portfolio.component.html',
	styleUrls: ['./portfolio.component.scss'],
	providers: [BbTableService, FilterSetService]
})

export class PortfolioComponent implements OnInit, OnDestroy {
	@ViewChild('editAppTemplate') editAppTemplate: TemplateRef<any>;
	@ViewChild('createAppTemplate') createAppTemplate: TemplateRef<any>;
	appModal: ModalDefinition;
	currentTab = 'media';
	freeTextFilter = '';
	filterableMediaTypes: string[] = [];
	activeFilterPreset = '';
	filterConfig: any;
	baseFilterSet: any = [];
	searchQuery = '';
	contextMenuStyle: any = { display: 'none' };
	contextMenuOptions: ContextMenuOption[] = [];
	parentEntity: SapiEntity;
	templateProjectId: string;

	protected rows: TableRow[] = null;
	protected subscriptions: Subscription = new Subscription();
	private designAspectRatio = 16 / 9;

	constructor(
		protected bbTableService: BbTableService,
		protected uploadService: UploadService,
		protected sapiService: SapiService,
		protected entityService: EntityService,
		protected interactivityEditorService: InteractivityEditorService,
		protected interactivityStateService: InteractivityStateService,
		protected publicationService: PublicationService,
		protected widgetService: InteractivityWidgetService,
		protected filterSetService: FilterSetService,
		protected overlayService: OverlayService,
		private interactivityDesignDimensionsService: InteractivityDesignDimensionsService) {

		this.filterConfig = {
			search: true,
			filters: [],
			presets: [
				{
					label: '',
					value: 'video',
					filterSet: [{
						filters: [{
							type: 'mediaclip',
							field: 'mediatype',
							operator: 'is',
							value: 'video'
						}]
					}],
				},
				{
					label: '',
					value: 'image',
					filterSet: [{
						filters: [{
							type: 'mediaclip',
							field: 'mediatype',
							operator: 'is',
							value: 'image'
						}]
					}],
				},
				{
					label: '',
					value: 'audio',
					filterSet: [{
						filters: [{
							type: 'mediaclip',
							field: 'mediatype',
							operator: 'is',
							value: 'audio'
						}]
					}],
				},
				{
					label: '',
					value: 'font',
					filterSet: [{
						filters: [{
							type: 'mediaclip',
							field: 'mediatype',
							operator: 'is',
							value: 'font'
						}]
					}],
				},
				{
					label: '',
					value: 'document',
					filterSet: [{
						filters: [{
							type: 'mediaclip',
							field: 'mediatype',
							operator: 'is',
							value: 'document'
						}]
					}],
				},
			]
		};

	}

	ngOnInit() {
		this.bbTableService
			.useOverlayLoading(false)
			.setSelect(BbTableSelectOption.none)
			.sort('createddate', 'desc')
			.setLimit(15)
			.setEntity('commonclip')
			.setLiveUpdates(true);

		this.subscriptions.add(this.interactivityEditorService.parentEntitySubject.subscribe((entity) => this.parentEntity = entity));
		this.subscriptions.add(this.bbTableService.rowsRetrievedObservable.subscribe((rows: TableRow[]) => this.rows = rows));

		this.subscriptions.add(this.interactivityStateService.propSub('portfolioSettings').subscribe((portfolioSettings: any) => {
			if (portfolioSettings && portfolioSettings.openTab) {
				this.onTabChange(portfolioSettings.openTab);
			} else {
				this.onTabChange('media');
			}
		}));
		this.subscriptions.add(this.interactivityDesignDimensionsService.designDimensionsSubject.subscribe((designDimensions: DesignDimensions) => {
			if (designDimensions.height > 0) {
				this.designAspectRatio = designDimensions.width / designDimensions.height;
			}
		}));

		this.filterableMediaTypes = ['video', 'image', 'audio', 'textLabel', 'document'];

		this.uploadService.completedObservable.subscribe(() => this.bbTableService.getRows(true));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	onProjectChange() {
		this.interactivityEditorService.loadEntityData('Project', this.templateProjectId, true);
	}

	createNewApp() {
		this.openEditAppModal();
	}

	editApp(app: any) {
		this.openEditAppModal(app);
	}

	openEditAppModal(app?: any) {
		this.appModal = {
			icon: 'object-group',
			title: app ? 'Edit template' : 'Create new template',
			component: {
				theme: 'dark-theme',
				name: 'custom-content',
				templateRef: app ? this.editAppTemplate : this.createAppTemplate
			}
		};
		this.overlayService.createModal(this.appModal);
	}

	setTab(tab: string) {
		this.onTabChange(tab);
		this.interactivityStateService.setPropState('portfolioSettings', { openTab: tab });
	}

	onRowDragStart(row: any, ev: DragEvent) {
		if (row && row.data &&
			(row.data.type === 'App' && this.interactivityEditorService.parentEntityType === 'App') ||
			(row.data.type === 'MediaClip' &&
				(row.data.mediatype !== 'video' && row.data.mediatype !== 'audio' && row.data.mediatype !== 'image')
			)
		) {
			ev.preventDefault();
			return;
		}

		let imgDimensions = null;
		if (ev && ev.target) {
			const img = (ev.target as HTMLElement).querySelector('img');
			if (img && img.naturalWidth && img.naturalHeight) {
				imgDimensions = {
					naturalWidth: img.naturalWidth,
					naturalHeight: img.naturalHeight
				};
			}
		}

		if (row && row.data && row.data.id) {
			ev.dataTransfer.setData('text/plain', JSON.stringify({ ...row.data, ...imgDimensions }));
		}
	}

	updateTable() {
		this.bbTableService.getRows(true);
	}

	importTimeline(id: string, fromMediaClip: Mediaclip) {
		this.interactivityEditorService.importTimeline(id, fromMediaClip);
	}

	onTabChange(tab: string) {
		this.rows = [];
		this.currentTab = tab;
		this.baseFilterSet = [];
		this.activeFilterPreset = '';
		this.searchQuery = '';
		switch (tab) {
			default:
			case 'media':
				this.bbTableService.setEntity('commonclip');
				break;

			case 'assets':
				this.bbTableService.setEntity('commonclip');
				break;

			case 'templates':
				this.bbTableService.setEntity('app');
				break;

			case 'timelines':
				this.bbTableService.setEntity('commonclip');
				this.baseFilterSet = [{
					filters: [{
						type: 'mediaclip',
						field: 'timelines',
						operator: 'is',
						value: '[1 TO *]'
					}]
				}];
				break;
		}
		this.bbTableService.setQuery(this.searchQuery);
		this.bbTableService.setBaseFilterSet(this.baseFilterSet);
		this.bbTableService.setFilterSet([]);
		this.bbTableService.setPage(1);
		this.updateTable();
	}

	onFilterClick(filterSetOption: any) {
		if (this.activeFilterPreset === filterSetOption.value) {
			this.activeFilterPreset = '';
			this.bbTableService.setFilterSet([]);
		} else {
			this.activeFilterPreset = filterSetOption.value;
			this.bbTableService.setFilterSet([...filterSetOption.filterSet]);
		}
		this.updateTable();
	}

	onSearchInputChange(value: string) {
		this.bbTableService.setQuery(value);
		this.updateTable();
	}

	onMediaContextMenu(ev: any, item: any) {
		if (ev) {
			ev.preventDefault();
			ev.stopPropagation();

			if (ev.target && item && item.data) {
				const row: any = ev.target.closest('bb-table-row');
				if (row) {
					const img: any = row.querySelector('img');
					if (img && img.naturalWidth && img.naturalHeight) {
						item.data.naturalWidth = img.naturalWidth;
						item.data.naturalHeight = img.naturalHeight;
					}
				}
			}
		}

		this.contextMenuOptions = [];
		const placeableMediaTypes = ['video', 'audio', 'image'];
		if (item && item.data && (placeableMediaTypes.indexOf(item.data.mediatype) > -1) || item.data.type === 'App') {
			if (this.interactivityEditorService.parentEntityType !== 'App') {
				this.contextMenuOptions.push({
					item,
					label: `Place "${item.label || item.data.title || item.data.originalfilename || item.data.name || ''}" as widget`,
					value: 'place_as_widget',
					icon: 'plus'
				});
			}
			this.contextMenuOptions.push({
				item,
				label: `Delete "${item.label || item.data.title || item.data.originalfilename || item.data.name || ''}"`,
				value: 'delete',
				icon: 'trash',
				onSelected: () => {
					this.entityService.deleteEntity(item.data, item.data.type === 'MediaClip' ? 'mediaclip' : 'app');
				}
			});
		}

		if (this.contextMenuOptions.length > 0) {
			this.contextMenuShow(ev.pageX, ev.pageY);
		}
	}

	onContextMenuOptionSelected(option: ContextMenuOption): void {
		switch (option.value) {
			case 'place_as_widget':
				if (option && option.item && option.item.data && option.item.data.id) {
					this.placeAsWidget(option.item.data);
				}
				break;
		}
		this.contextMenuHide();
	}

	contextMenuHide() {
		this.contextMenuStyle.display = 'none';
	}

	private contextMenuShow(posX: number, posY: number): void {
		this.contextMenuStyle.display = 'block';
		this.contextMenuStyle.left = posX + 'px';
		this.contextMenuStyle.top = posY + 'px';
	}


	private placeAsWidget(itemData: any): void {
		let changedProps: any = null;
		let widgetType: WidgetType;
		let widgetLabel = '';

		if (itemData && itemData.mediatype && itemData.id) {
			widgetLabel = itemData.title;
			switch (itemData.mediatype) {
				case 'video':
					widgetType = WidgetType.Video;
					changedProps = { clipid: itemData.id };
					break;

				case 'audio':
					widgetType = WidgetType.Audio;
					changedProps = { clipid: itemData.id };
					break;

				case 'image':
					widgetType = WidgetType.Image;
					changedProps = { imageid: itemData.id };
					break;
			}
			if (itemData.naturalWidth && itemData.naturalHeight) {
				changedProps.width = 15;
				changedProps.height = (changedProps.width / (itemData.naturalWidth / itemData.naturalHeight)) * this.designAspectRatio;
				changedProps.width += '%';
				changedProps.height += '%';
			}
		} else if (itemData.type === 'App' && itemData.id) {
			widgetType = WidgetType.App;
			widgetLabel = itemData.name;
			changedProps = { appid: itemData.id, xpos: 0, ypos: 0 };
		}

		if (changedProps) {
			this.widgetService.createWidget(widgetType, { ...changedProps }, null, null, widgetLabel);
		}
	}
}
